export default __webpack_public_path__ + "static/media/tier-c-bg.0b0289b3.png";